import styled from 'styled-components';

const IconContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 0;
  top: 0;
  bottom: 0;
`;

const HomeworkRow = styled.div`
  display: flex;
  align-items: center;
  direction: "row";
  gap: ${({ theme }) => theme.spacing(1)};
  background-color: ${({ theme }) => theme.palette.backdrop.main};
  :nth-child(even) {
    background-color: ${({ theme }) => theme.palette.backdrop.light};
  }
  border-radius: ${({ theme }) => theme.shape.borderRadius * 2}px;
  padding-left: ${({ theme }) => theme.spacing(1)};
`;

const StudentProfileSection = styled.div`
  display: flex;
  align-items: center;
  direction: "row";
  gap: ${({ theme }) => theme.spacing(1)};
  width: 200px;
  height: 64px;
`;

export { IconContainer, HomeworkRow, StudentProfileSection };
